import React, { useState } from 'react';
import LeftNav from '../../../Design/LeftNav/LeftNav';
import Main from '../../../Design/LeftNav/Main';
import styles from './Securities.module.css';
import { LeftNavLinks } from '../../../Design/LeftNav/LeftNavLinks';

function Securities() {
  // Default to first tab
  const [activeTab, setActiveTab] = useState(LeftNavLinks.securities[0]?.key || "equities");

  const handleTabClick = (key) => {
    setActiveTab(key); // Update active tab on click
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftNav}>
        <LeftNav 
          section="securities"
          activeTab={activeTab} 
          onTabClick={handleTabClick} 
        />
      </div>
      <div className={styles.pageContent}>
        <Main activeTab={activeTab} />
      </div>
    </div>
  );
}

export default Securities;